import { render } from "./menu-tree.vue?vue&type=template&id=721f6f3e&scoped=true"
import script from "./menu-tree.vue?vue&type=script&lang=js"
export * from "./menu-tree.vue?vue&type=script&lang=js"

import "./menu-tree.vue?vue&type=style&index=0&id=721f6f3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721f6f3e"]])

export default __exports__